const distributionActionsData = {
    asset: "assetDistribution",
    metadata: "metadataDistribution",
    takedown: "takedownDistribution",
    tracks: "tracksDistribution",
    video: "videoDistribution",
};

export default distributionActionsData;
